import styled from "styled-components";

import { Container as BaseContainer } from "../../Container";

export const QueueStatusButton = styled.button<{ inQueue: boolean }>`
  border-radius: 20px;
  height: 32px;
  width: 32px;
  background-image: ${({ inQueue }) =>
    inQueue
      ? "radial-gradient(100% 2434.05% at 2.19% 0%, #2C8DFF 0%, #0075FF 100%)"
      : ""};
  background-color: #e1e5e9;
  color: ${({ inQueue }) => (inQueue ? "white" : "black")};
  border: none;
  outline: none;
  align-self: center;
  margin-left: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  & > * {
    flex-shrink: 0;
  }
`;

export const Container = styled(BaseContainer)`
  background-color: #f7f8f9;
`;

export const CompetitorsList = styled.div`
  margin-top: 6px;
`;

export const CompetitorsQueueList = styled(CompetitorsList)`
  border-bottom: 1px solid #e7e8e9;
  margin: 0 -12px;
  padding: 12px;
  > div {
    margin-bottom: 8px;
  }
`;

export const CompetitorsListItem = styled.div`
  padding: 8px 0;
  margin-bottom: 2px;
`;

export const CompetitorsQueueListItem = styled(CompetitorsListItem)`
  background: white;
  border-radius: 8px;
  padding: 8px;
`;

export const ContainerUpper = styled.div`
  margin: -12px -12px 12px;
  padding: 0 12px;
  background: white;
`;

export const QueueHeading = styled.div`
  font-weight: bold;
  font-size: 14px;
  color: #69738a;
  margin-top: 16px;
`;

export const SearchRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
